//let prodUrl="http://vueshop.glbuys.com";//生成环境
//let devUrl="/proxy";//开发者环境
//let baseUrl=process.env.NODE_ENV==='development'?devUrl:prodUrl;
let baseUrl = 'http://ptt.zlgxt.cn:8011/';

export default {
    baseUrl:baseUrl,
    path:"/",
    token:""
}